<script lang="ts">
    import { getDBEntries, getDBEntry } from "../../api"
    import { location, rerenderSteps, sidebarOverlay, taskEditors } from "../store"
    import OrderTitleRow from "../taskSteps/widgets/OrderTitleRow.svelte"
    import StepTab from "../taskSteps/widgets/StepTab.svelte"
    import TaskTitleRow from "../taskSteps/widgets/TaskTitleRow.svelte"
    import { changeStep } from "../utils"
    import { getQueryParam } from "./formComponents/helper"

    function extractOrderIdFromPath(path: string): string {
        if (path.includes("order")) {
            return path.split("order/")[1].split("/")[0]
        } else {
            return ""
        }
    }

    function extractTaskIdFromPath(path: string): string {
        if (path.includes("task")) {
            return path.split("task/")[1].split("/")[0]
        } else {
            return ""
        }
    }
    function getCurrentStepNr(path: string): number {
        if (path.includes("task")) {
            return getQueryParam("selectedStep") ? Number(getQueryParam("selectedStep")) - 1 : 0
        } else return -1
    }

    const getSteps = async (taskType: string) => {
        await getDBEntries("taskStepsConfig", {
            name: taskType,
        }).then((response) => {
            const taskSteps = response[0]
            if (taskSteps) {
                steps = taskSteps.config.steps
            }
        })
    }

    $: state = {
        orderId: extractOrderIdFromPath($location.path),
        taskId: extractTaskIdFromPath($location.path),
        currentStepNr: getCurrentStepNr($location.path),
        taskEditors: $taskEditors,
    }
    let order: Order, task: Task, steps: TaskStep[]
    $: selectedStep = state.currentStepNr
    $: if ((!order && state.orderId) || (state.orderId && order && state.orderId !== order.id)) {
        getDBEntry("order", {
            _id: state.orderId,
        }).then((res) => (order = res))
    }

    $: if ((!task && state.taskId) || (state.taskId && task && state.taskId !== task.id)) {
        getDBEntry("task", {
            _id: state.taskId,
        }).then((res) => (task = res))
        getSteps(task?.generalDetails?.taskType)
    }
</script>

{#if order}
    <div class="overview-container">
        <div class="black row">
            <OrderTitleRow order="{order}" />
        </div>

        {#if task}
            <div class="black row">
                <TaskTitleRow task="{task}" />
            </div>
            {#if steps}
                <ul class="steps">
                    {#each steps as step, i}
                        <li>
                            <StepTab
                                changeStep="{changeStep}"
                                stepIndex="{i}"
                                task="{task}"
                                bind:selectedStep="{selectedStep}"
                                step="{step}"
                                on:stepSelected="{() => {
                                    $sidebarOverlay = false
                                }}"
                                showBlocked="{true}"
                            />
                        </li>
                    {/each}
                </ul>
            {/if}
        {/if}
    </div>
{/if}

<style
    lang="less"
    global
>
    @import "../../../assets/variables.less";

    .overview-container {
        flex-grow: 1;
        background-color: var(--text-000);
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 1.2rem;

        .row {
            padding: 0rem 3.6rem;
            @media @mobile {
                padding: 0rem 1.2rem;
            }
            background-color: transparent;
            &.black {
                background-color: var(--text-000);
            }
        }
        .steps {
            display: flex;
            flex-grow: 1;
            flex-direction: column;
            background: var(--grey-200);
            li {
                button {
                    border-radius: 0px !important;
                    width: 100%;
                    height: unset;
                    padding: 0.8rem 3.6rem !important;
                    @media @mobile {
                        padding: 0.8rem 1.2rem !important;
                    }
                    &.completed {
                        background-color: var(--grey-200) !important;
                    }
                    &.active {
                        background-color: white !important;
                        &:not(.blocked) > div {
                            gap: 0px !important;
                            p {
                                color: var(--text-100) !important;
                            }
                            & > div {
                                display: none !important;
                            }
                        }
                    }
                    &.blocked {
                        background-color: var(--red-100) !important;
                    }
                }
            }
        }
    }
</style>
